module.exports = __webpack_public_path__ + "static/img/cont43_09.bb66434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_09.jpg
// module id = hhIb
// module chunks = 0